import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlinedFlag, MdOutlineEventSeat } from "react-icons/md";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Select Your Shows",
    description: "Select 3 or more shows you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to your Ticketmaster Account",
    description: (
      <>
        Connect to your Ticketmaster account using the secure Ticketmaster
        Login. This log-in information should match your current
        Ticketmaster.com account.
        <br />
        If you do not have an account, use “New to Ticketmaster? Sign Up” option
        beneath “Sign In” to create one.
      </>
    ),
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: (
      <>
        We'll do our best to find the same locations for each show in your
        series, but they may vary based on availability. You'll see all the
        details before finalizing your order.
        <br />
        <b>
          <u>Please Note:</u> Some seating options presented may be shared
          spaces. If the seats you select do not make up an entire box or suite,
          the remaining seats may be sold to other parties. This will be more
          likely when purchasing seats in pairs.
        </b>
      </>
    ),
  },
  {
    icon: <HiOutlineTicket />,
    title: "Access Your Tickets",
    description: (
      <>
        Tickets will be available in your Ticketmaster Account Manager after
        purchase. Your venue's dedicated Account Representative will introduce
        themselves to you via email or phone in the days following your
        purchase. They will be happy to answer any additional questions you may
        have. If you have questions in the meantime, please reach out to{" "}
        <Link
          target="_blank"
          href="mailto:premiumtickets@livenation.com"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
        >
          premiumtickets@livenation.com
        </Link>
        .
      </>
    ),
  },
];

export const faqs = [
  {
    title: "What if I don't already have a Ticketmaster Account?",
    description: `Simply create an account directly from the log-in page by clicking "Sign Up".`,
  },
  {
    title: "How does the Premium Seat Series program work?",
    description:
      "This program allows you to create your own package of three or more shows, all with tickets in our most exclusive seats that include in-seat waitstaff and elevated food and beverage offerings. Simply log in to select your shows, log into your Ticketmaster Account manager, select your premium seat location(s), and check out.",
  },
  {
    title: "Do I have to select all my shows now?",
    description:
      "Yes, you must select a minimum of 3 shows at the time of purchase to participate in the program.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "You can choose from any currently available premium seats.",
  },
  {
    title: "Can I pick the same location for every show?",
    description:
      "We will do our best to find the same locations for each show in your series, but they may vary based on availability. All seats will be in premium locations.",
  },
  {
    title: "Can I transfer these tickets to my friends and family?",
    description:
      "You may transfer tickets to others via the Account Manager platform. Please note that in limited circumstances, tickets may be subject to transfer restrictions at the request of the artist.",
  },
  {
    title: "How do I find my tickets?",
    description:
      "Tickets will be available in your Ticketmaster Account Manager account after purchase. Simply sign in with the same account as you did to purchase your series package.",
  },
  {
    title: "How do I use my tickets?",
    description: (
      <>
        Tickets can be added to a mobile wallet (Apple Wallet on iOS or Google
        Wallet on Android devices) or viewed within the Live Nation app. Tickets
        added to mobile wallets utilize Tap to Enter technology - no barcode
        necessary!
        <br />
        We recommend adding tickets to your mobile wallet in advance of arriving
        at the venue to ensure a seamless entry experience.
      </>
    ),
  },
  {
    title: "Is there someone I can reach out to with questions?",
    description:
      "Your dedicated Account Representative will introduce themselves to you via email or phone in the days following your purchase. They will be happy to answer any additional questions you may have.",
  },
  {
    title:
      "Do these tickets include any amenities such as club access or parking?",
    description: (
      <>
        Upgrades to The Backyard, our new outdoor hangout spot, may be available
        to purchase upon checkout. It is a space that is designed for summer
        fun, rooted in music, and most of all, inspired by great American
        backyards.
      </>
    ),
  },
  {
    title: "Am I able to swap out a show I cannot attend?",
    description: "Due to the nature of live events, show selections are final.",
  },
  {
    title: "Can I add events to my series package later?",
    description:
      "Your Account Representative will be happy to discuss options for adding shows to your initial package.",
  },
  {
    title: "What happens if a show I selected cancels?",
    description:
      "If a show is canceled, your Account Representative will work with you to select another show within the 2025 concert season as part of your package. If another show is not available or selected, you will receive credit towards a Premium package purchase in 2026. If you require a refund, you may request this in writing.",
  },
];
